export const getContentIdFromSlug = (slug: string | undefined | null): number | typeof NaN => {
  const disectedSlug = slug?.split('-') ?? [];

  const contentId = parseInt(disectedSlug[0]);

  return contentId.toString() === disectedSlug[0] ? contentId : NaN;
};
